// import { API } from '@service';

/* eslint-disable no-undef */
export default class PendoIO {
  /* send track events to pendo, visit https://app.pendo.io/s/5756831247237120/*/
  static track(name, payload) {
    if (pendo && pendo.isReady && pendo.isReady()) {
      console.log('tracking...', name);
      console.log('payload: ', payload);
      return pendo.track(name, payload);
    }
    setTimeout(function () {
      PendoIO.track(name, payload);
    }, 500);
    return true;
  }

  static async initialize(userInfo) {
    if (!userInfo || !userInfo.uid) {
      return;
    }
    // const { uid } = userInfo;
    // const additionalUserInfo =
    //   (await API.queryMemberInfoByGuid(uid))?.members.find(
    //     (m) => m.guid === uid,
    //   ) || {};
    console.log('Pendo initilaizing...');
    pendo.initialize({
      account: {
        id: userInfo.uid,
        full_name: `${userInfo.given_name} ${userInfo.family_name}`,
        title: userInfo?.title || '',
      },
      disableCookies: true,
    });
  }
}
